// IconHeaderComponent.tsx
import React, { useEffect, useState } from "react";
import { IHeaderParams } from "ag-grid-community";

interface IconHeaderComponentProps extends IHeaderParams {
  iconClasses: string[]; // Array of icon classes
  iconColor?: string; // Optional prop for icon color
  showHeaderName?: boolean; // Optional prop to control header name display
}

const IconHeaderComponent: React.FC<IconHeaderComponentProps> = (props) => {
  const [sortIcon, setSortIcon] = useState<string | null>(null);

  useEffect(() => {
    const currentSort = props.column.getSort();
    if (currentSort === "asc") {
      setSortIcon("↑");
    } else if (currentSort === "desc") {
      setSortIcon("↓");
    } else {
      setSortIcon(null);
    }
  }, [props.column]);

  const onSortRequested = () => {
    if (props.columnApi) {
      const currentSort = props.column.getSort();
      let nextSort: "asc" | "desc" | null = null;

      if (currentSort === "asc") {
        nextSort = "desc";
      } else if (currentSort === "desc") {
        nextSort = null;
      } else {
        nextSort = "asc";
      }

      // Reset sort state of other columns
      const allColumns = props.columnApi.getAllGridColumns();
      const columnState = props.columnApi.getColumnState();
      const updatedState = columnState.map((state) => {
        if (state.colId !== props.column.getColId()) {
          return { ...state, sort: null };
        }
        return state;
      });

      // Set sort state of the current column
      updatedState.push({ colId: props.column.getColId(), sort: nextSort });
      props.columnApi.applyColumnState({
        state: updatedState,
        applyOrder: true,
      });

      // Update sort icon
      if (nextSort === "asc") {
        setSortIcon("↑");
      } else if (nextSort === "desc") {
        setSortIcon("↓");
      } else {
        setSortIcon(null);
      }
    }
  };

  return (
    <div
      className="custom-header"
      onClick={onSortRequested}
      style={{ display: "flex", alignItems: "center" }}
    >
      {props.iconClasses.map((iconClass, index) => (
        <i
          key={index}
          className={iconClass}
          style={{ color: props.iconColor, marginRight: "5px" }}
        ></i>
      ))}
      {props.showHeaderName && <span>{props.displayName}</span>}
      {sortIcon && <span style={{ marginLeft: "5px" }}>{sortIcon}</span>}
    </div>
  );
};

export default IconHeaderComponent;
